import { render, staticRenderFns } from "./ChangePasswordForm.vue?vue&type=template&id=0e53f9ce&scoped=true"
import script from "./ChangePasswordForm.vue?vue&type=script&lang=js"
export * from "./ChangePasswordForm.vue?vue&type=script&lang=js"
import style0 from "./ChangePasswordForm.vue?vue&type=style&index=0&id=0e53f9ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e53f9ce",
  null
  
)

export default component.exports